<ng-container>
  <!-- MP direction Summary-->
  <div class="v-center" style="font-size: 14px; gap: 4px; justify-content: end; padding: 8px 20px;"> 
    <div class="default-label small-font">General : {{ generalTypeCount }}</div>
    <div class="default-label small-font">Installation : {{ installationTypeCount }}</div>
    <div class="default-label small-font">Accounting : {{ accountingTypeCount }}</div>
    <div class="default-label small-font">Service : {{ serviceTypeCount }}</div>
    <div class="default-label small-font">Sales : {{ salesTypeCount }}</div>
    <div class="default-label small-font">None : {{ noContentTypeCount }}</div>
  </div>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-area" *ngIf="!isLoading" style="height: calc(100% - 35px);">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumnInServiceNote($event)">
        <colgroup>
          <col *ngFor="let col of serviceTableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of serviceTableHeader" [sortable-column]="header.value">
               {{header.name}}</th>
          </tr>
        </thead>
      </table>
      <div class="alternative-contents" *ngIf="determineElementToShowInServiceNoteTable() === 'no-data'"> <i class="material-icons">inventory_2</i>
        <div>No Service Notes</div>
      </div>
      <div class="alternative-contents" *ngIf="determineElementToShowInServiceNoteTable() === 'no-permission'"> <i class="material-icons">do_not_disturb_on</i>
        <div>Permission Denied</div>
      </div>
      <div class="table-body" style="max-height: calc(100% - 139px);" *ngIf="determineElementToShowInServiceNoteTable() === 'normal'">
        <table>
          <colgroup>
            <col *ngFor="let col of serviceTableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <ng-container *ngIf="!isLoading">
              <tr *ngFor="let serviceNote of pagedItems">
                <td [class.no-contents]="!serviceNote.type_label">{{serviceNote.site_id}}</td>
                <td [class.unknown]="serviceNote.site_name === 'No Site Name'" [class.no-contents]="!serviceNote.type_label"> 
                  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                    <div class="ellipsis">{{serviceNote.site_name}}</div>
                    <div class="--g-tooltip tooltip-background">{{serviceNote.site_name}}</div>
                  </div>
                </td>
                <td [class.unknown]="serviceNote.title === 'No Title'" [class.no-contents]="!serviceNote.type_label"> 
                  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                    <div class="ellipsis">{{serviceNote.title}}</div>
                    <div class="--g-tooltip tooltip-background">{{serviceNote.title}}</div>
                  </div>
                </td>
                <td [class.no-contents]="!serviceNote.type_label">{{serviceNote.type_label}}</td>
                <td [class.no-contents]="!serviceNote.type_label">{{serviceNote.created_at ?? '-'}}</td>
                <td [class.no-contents]="!serviceNote.type_label">{{serviceNote.updated_at ?? '-'}}</td>
                <td>
                  <div class="more-content v-center" #serviceNoteActionMenus [id]="'service-note-'+serviceNote.id" (mouseover)="setMorePosition(serviceNote.id)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(serviceNote)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [class.show]="serviceNote.isShowMenu" [id]="'service-note-more-'+serviceNote.id">
                      <div class="more-item pointer row" *ngIf="serviceNote?.type" (click)="goToServiceNoteDetail($event, serviceNote)">
                        <div>Go to Detail</div>
                      </div>
                      <div class="more-item pointer row" *ngIf="!serviceNote?.type" (click)="goToAddServiceNote($event, serviceNote)">
                        <div>Add Service Note</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- pagination-->
      <div class="pagination-area">
        <div style="font-size:12px;padding-right: 7px;"></div>
        <div class="space"></div>
        <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
          <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
          <div>of </div>
          <div>{{totalItem}}</div>
        </div>
        <div class="pagination">
          <div class="page-mover">
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
                <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
              </div>
            </div>
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
                <div class="btn-inner"><span>Next</span>
                  <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>